module.exports = "<p>{{title}}</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 378
// module chunks = 1